<template >
  <Modal v-model="isVisible" title="导出" width="800">
    <div class="quality-edit">
      <Form
        class="quality-edit-form"
        ref="batchQualityEdit"
        :model="formData"
        :rules="formRule"
        :label-width="100"
        label-position="right"
      >
        <Form-item label="导出图片: " prop="exportImage">
          <RadioGroup v-model="formData.exportImage">
            <Radio label="1">是</Radio>
            <Radio label="2">否</Radio>
          </RadioGroup>
        </Form-item>
        <Form-item :label="`导出${tabType}数量: `" prop="exportImage">
          <span style="color: #f20; font-size: 16px;">{{total}}</span>
        </Form-item>
      </Form>
      <Spin v-if="pageLoading" fix></Spin>
    </div>
    <div slot="footer">
      <Button @click="isVisible = false">取 消</Button>
      <Button type="primary" @click="saveData" :disabled="pageLoading">确 定</Button>
    </div>
  </Modal>
</template>

<script>
// import api from '@/api/api';

export default {
  name: 'batchQualityEdit',
  props: {
    modalVisible: { type: Boolean, default: false },
    refreshTable: { type: Boolean, default: false },
    modalData: {
      type: Object,
      default: () => {
        return {
          reqApi: '',
          params: {},
          tabType: '',
          total: 0
        }
      }
    }
  },
  data () {
    return {
      isVisible: false,
      // 表单数据组
      formData: {
        exportImage: '2'
      },
      // 表单验证规则
      formRule: {},
      oldFormData: {},
      pageLoading: false
    }
  },
  watch: {
    modalVisible: {
      immediate: true,
      handler (val) {
        this.isVisible = val;
        val ? this.initData() : this.restData();
      }
    },
    isVisible: {
      handler (val) {
        this.$emit('update:modalVisible', val);
      }
    }
  },
  created () {},
  computed: {
    reqApi () {
      return this.modalData.reqApi;
    },
    params () {
      return { ...this.modalData.params, ...this.formData };
    },
    tabType () {
      return this.modalData.tabType || 'SPU';
    },
    total () {
      return this.modalData.total;
    }
  },
  methods: {
    // 初始化页面数据
    initData () {
      // this.pageLoading = true;
      this.oldFormData = this.$common.copy(this.formData);
    },
    // 保存
    saveData () {
      this.pageLoading = true;
      this.axios.post(this.reqApi, this.params).then((response) => {
        this.pageLoading = false;
        if (response.data.code === 0) {
          let data = response.data.datas;
          this.$Message.success({
            content: '已生成导入/导出任务，任务编号' + '：' + data,
            duration: 10,
            closable: true
          });
          this.$nextTick(() => {
            this.isVisible = false;
          })
        }
      }).catch(() => {
        this.pageLoading = false;
      })
    },
    // 重置页面数据
    restData () {
      !this.$common.isEmpty(this.oldFormData) && (this.formData = this.$common.copy(this.oldFormData));
    }
  }
};
</script>
